require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-how-is-the-afdb-addressing-social-risks-in-a-high-risk.json") })
        }
      }, "path---en-us-project-how-is-the-afdb-addressing-social-risks-in-a-high-risk");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-how-is-the-afdb-addressing-social-risks-in-a-high-risk!./.cache/json/en-us-project-how-is-the-afdb-addressing-social-risks-in-a-high-risk.json
// module id = 521
// module chunks = 231608221292675